import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { FC } from 'react';

type HeaderElementProps = {
  text: string;
};

const HeaderElement: FC<HeaderElementProps> = ({ text }) => (
  <Text color="inherit">{text}</Text>
);

export const ReadonlyCustomerListHeader: FC = () => (
  <Box
    m={0}
    h="40px"
    w="100%"
    pl="16px" // list-item の padding-left に合わせる
    pr="16px" // スクロールバー分の余白
    borderBottom="2px"
    borderBottomColor="secondaryList.header.borderColor"
    bgColor="secondaryList.header.bgColor"
  >
    <Grid
      h="100%"
      templateColumns="4fr 10fr 15fr"
      gap={0}
      justifyItems="start"
      alignItems="center"
    >
      <GridItem pr="20px">
        <HeaderElement text="ID" />
      </GridItem>
      <GridItem pl="20px">
        <HeaderElement text="名前" />
      </GridItem>
      <GridItem pl="20px">
        <HeaderElement text="詳細" />
      </GridItem>
    </Grid>
  </Box>
);
